module.exports = __webpack_public_path__ + "img/horizontal_4_6_0.d36de029.png";